module.exports = __webpack_public_path__ + "static/media/EventGray.ca67bcf2.svg";